<script>
import { Line } from "vue-chartjs"
export default {
  extends: Line,
  props: ["labels", "data", "legend"],
  methods: {
    render() {
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              label: this.legend,
              backgroundColor: "#f87979",
              data: this.data,
              borderColor: "#f87979",
              pointBackgroundColor: "white",
              borderWidth: 2,
              pointBorderColor: "#f87979",
              pointBorderWidth: 2,
            },
          ],
        },
        {
          layout: {
            padding: {
              left: 10,
              right: 10,
              top: 10,
              bottom: 10,
            },
          },
          legend: { display: false },
          responsive: true,
          maintainAspectRatio: true,
          scales: {
            xAxes: [
              {
                gridLines: {
                  color: "rgba(0, 0, 0, 0.05)",
                  zeroLineColor: "rgba(0, 0, 0, 0.1)",
                },
                ticks: {
                  display: false,
                },
              },
            ],
            yAxes: [
              {
                gridLines: {
                  color: "rgba(0, 0, 0, 0.05)",
                  zeroLineColor: "rgba(0, 0, 0, 0.1)",
                },
                ticks: {
                  display: false,
                  beginAtZero: true,
                },
              },
            ],
          },
        }
      )
    },
  },
  mounted() {
    // Overwriting base render method with actual data.

    this.render()
    console.log("ESTO RECIBI DE DATA", this.legend)
  },
  watch: {
    data() {
      this.render()
    },
  },
}
</script>
